import React from "react"
import styles from "./styles.js"
import logo from "../../../assets/firstline_social_logo.png"

const TermsConditions = ({ classes }) => {
  return (
    <div>
      <style dangerouslySetInnerHTML={{ __html: styles }} />
      <div className="headerContainer">
        <img src={logo} className="image" alt="FirstLine Social Logo" />
      </div>
      <div className="termsContainer">
        <div>
          <p className="c14">
            <span className="c6 c15" />
          </p>
        </div>
        <a id="id.gjdgxs" />
        <p className="c12">
          <span className="c4 c16">FirstLine Social Terms and Conditions</span>
        </p>
        <p className="c2">
          <span className="c3">
            These FirstLine Social Terms and Conditions (this &quot;
          </span>
          <span className="c6 c4">Agreement</span>
          <span className="c3">
            &quot;), are effective as of the date &ldquo;
          </span>
          <span className="c6 c4">You</span>
          <span className="c3">&rdquo; access our Services (the &ldquo;</span>
          <span className="c6 c4">Effective Date</span>
          <span className="c3">
            &rdquo;). If You are accessing or using the Services on behalf of an
            organization or entity (&quot;
          </span>
          <span className="c6 c4">Customer</span>
          <span className="c3">
            &quot;), then you are agreeing to this Agreement on behalf of that
            Customer and you represent and warrant that you have the authority
            to bind the Customer to this Agreement. In that case,
            &quot;you&quot; and &quot;your&quot; refers to you and Customer.
            This Agreement is entered into by and between You and FIRSTLINE
            SOCIAL, LLC, an Oklahoma limited liability company (&ldquo;
          </span>
          <span className="c6 c4">FirstLine Social</span>
          <span className="c3">
            &rdquo;, &ldquo;We,&rdquo; &ldquo;Us,&rdquo; &ldquo;Our&rdquo;).
            Customer and FirstLine Social may be referred to herein collectively
            as the &quot;
          </span>
          <span className="c6 c4">Parties</span>
          <span className="c3">&quot; or individually as a &quot;</span>
          <span className="c6 c4">Party</span>
          <span className="c3">
            .&quot; The FirstLine Social Privacy Policy is hereby incorporated
            by reference.
          </span>
          <span className="c6 c21">&nbsp;</span>
          <span className="c3">
            By accessing or using the Service you agree to be bound by this
            Agreement.{" "}
          </span>
        </p>
        <p className="c2">
          <span className="c3">
            WHEREAS, FirstLine Social provides access to its
            software-as-a-service platform offerings to its customers;
          </span>
        </p>
        <p className="c2">
          <span className="c3">
            WHEREAS, You desire to access certain software-as-a-service platform
            offerings described herein, and FirstLine Social desires to provide
            Your access to such offerings, subject to the terms and conditions
            set forth in this Agreement.
          </span>
        </p>
        <p className="c2">
          <span className="c3">
            NOW, THEREFORE, in consideration of the mutual covenants, terms, and
            conditions set forth herein, and for other good and valuable
            consideration, the receipt and sufficiency of which are hereby
            acknowledged, the parties agree as follows:
          </span>
          <a id="id.30j0zll" />
        </p>
        <ol className="c5 lst-kix_list_20-0 start" start="1">
          <li className="c0">
            <span className="c6 c4">Definitions</span>
            <a id="id.1fob9te" />
            <span className="c3">.</span>
          </li>
        </ol>
        <ol className="c5 lst-kix_list_20-1 start" start="1">
          <li className="c1">
            <span className="c3">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&quot;
            </span>
            <span className="c6 c4">Access Credentials</span>
            <span className="c3">
              &quot; means any user name, phone number, identification number,
              password, license or security key, security token, PIN, or other
              security code, method, technology, or device, used alone or in
              combination, to verify an individual&rsquo;s identity and
              authorization to access and use the Services.
            </span>
          </li>
          <li className="c1">
            <span className="c3">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&quot;
            </span>
            <span className="c6 c4">Action</span>
            <span className="c3">
              &quot; means any claim, action, cause of action, demand, lawsuit,
              arbitration, inquiry, audit, notice of violation, proceeding,
              litigation, citation, summons, subpoena, or investigation of any
              nature, civil, criminal, administrative, regulatory, or other,
              whether at law, in equity, or otherwise.
            </span>
          </li>
          <li className="c1">
            <span className="c3">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&quot;
            </span>
            <span className="c6 c4">Affiliate</span>
            <span className="c3">
              &quot; of a Person means any other Person that directly or
              indirectly, through one or more intermediaries, controls, is
              controlled by, or is under common control with, such Person
            </span>
          </li>
          <li className="c1">
            <span className="c3">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&quot;
            </span>
            <span className="c6 c4">Aggregated Statistics</span>
            <span className="c3">
              &quot; means data and information related to Customer&rsquo;s use
              of the Services that is used by FirstLine Social in an aggregate
              and anonymized manner, including to compile statistical and
              performance information related to the provision and operation of
              the Services
            </span>
          </li>
          <li className="c1">
            <span className="c3">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&quot;
            </span>
            <span className="c6 c4">Authorized User</span>
            <span className="c3">
              &quot; means Customer employees, consultants, contractors, and
              agents (i) who are authorized by Customer to access and use the
              Services under the rights granted to Customer
            </span>
            <a id="id.3znysh7" />
            <span className="c3">
              &nbsp;pursuant to this Agreement and (ii) for whom access to the
              Services has been purchased hereunder.
            </span>
          </li>
          <li className="c1">
            <span className="c3">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&quot;
            </span>
            <span className="c6 c4">Customer Data</span>
            <span className="c3">
              &quot; means, other than Aggregated Statistics, information, data,
              and other content, in any form or medium, that is submitted,
              posted, or otherwise transmitted by or on behalf of Customer
            </span>
            <a id="id.2et92p0" />
            <span className="c3">
              &nbsp;or an Authorized User through the Services.{" "}
            </span>
          </li>
        </ol>
        <a id="id.tyjcwt" />
        <ol className="c5 lst-kix_list_20-1" start="7">
          <li className="c1">
            <span className="c3">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&quot;
            </span>
            <span className="c6 c4">Customer Systems</span>
            <span className="c3">
              &quot; means the Customer&rsquo;s information technology
              infrastructure, including computers, software, hardware,
              databases, electronic systems (including database management
              systems), and networks, whether operated directly by Customer or
              through the use of third-party services.
            </span>
          </li>
          <li className="c1">
            <span className="c3">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&quot;
            </span>
            <span className="c6 c4">Documentation</span>
            <span className="c3">
              &quot; means FirstLine Social&#39;s user manuals, videos,
              handbooks, and guides relating to the Services provided by
              FirstLine Social to Customer either electronically or in hard copy
              form/end user documentation relating to the Services available at{" "}
            </span>
            <span className="c3">
              <a
                className="c9"
                href="https://www.google.com/url?q=http://www.firstlinesocial.com&amp;sa=D&amp;ust=1589216643027000"
              >
                www.firstlinesocial.com
              </a>
            </span>
            <span className="c3">
              &nbsp;or the subdomain We provide You with to access our Services.{" "}
            </span>
            <a id="id.3dy6vkm" />
            <span className="c3">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </span>
          </li>
          <li className="c1">
            <span className="c3">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&quot;
            </span>
            <span className="c6 c4">FirstLine Social IP</span>
            <span className="c3">
              &quot; means the Services, the Documentation, and any and all
              intellectual property provided to Customer or any Authorized User
              in connection with the foregoing. For the avoidance of doubt,
              FirstLine Social IP includes Aggregated Statistics and any
              information, data, or other content derived from FirstLine
              Social&#39;s monitoring of Your access to or use of the Services,
              but does not include Your
            </span>
            <a id="id.1t3h5sf" />
            <span className="c3">&nbsp;Data.</span>
          </li>
          <li className="c1">
            <span className="c3">&quot;</span>
            <span className="c6 c4">Harmful Code</span>
            <span className="c3">
              &quot; means any software, hardware, or other technology, device,
              or means, including any virus, worm, malware, or other malicious
              computer code, the purpose or effect of which is to (a) permit
              unauthorized access to, or to destroy, disrupt, disable, distort,
              or otherwise harm or impede in any manner any (i) computer,
              software, firmware, hardware, system, or network; or (ii) any
              application or function of any of the foregoing or the security,
              integrity, confidentiality, or use of any data Processed thereby;
              or (b) prevent Customer or any Authorized User from accessing or
              using the Services or FirstLine Social Systems as intended by this
              Agreement. Harmful Code does not include any FirstLine Social
              Disabling Device.
            </span>
          </li>
          <li className="c1">
            <span className="c3">&rdquo;</span>
            <span className="c6 c4">Intellectual Property Rights&rdquo;</span>
            <span className="c3">
              &nbsp;means any and all registered and unregistered rights
              granted, applied for, or otherwise now or hereafter in existence
              under or related to any patent, copyright, trademark, trade
              secret, database protection, or other intellectual property rights
              laws, and all similar or equivalent rights or forms of protection,
              in any part of the world.
            </span>
          </li>
          <li className="c1">
            <span className="c3">&ldquo;</span>
            <span className="c6 c4">Losses</span>
            <span className="c3">
              &quot; means any and all losses, damages, deficiencies, claims,
              actions, judgments, sett
            </span>
            <span className="c4 c6">l</span>
            <span className="c3">
              ements, interest, awards, penalties, fines, costs, or expenses of
              whatever kind, including reasonable attorneys&rsquo; fees and the
              costs of enforcing any right to indemnification hereunder and the
              cost of pursuing any insurance providers.
            </span>
          </li>
          <li className="c1">
            <span className="c3">&quot;</span>
            <span className="c6 c4">Person</span>
            <span className="c3">
              &quot; means an individual, corporation, partnership, joint
              venture, limited liability entity, governmental authority,
              unincorporated organization, trust, association, or other entity.
            </span>
          </li>
          <li className="c1">
            <span className="c3">&nbsp;&quot;</span>
            <span className="c6 c4">Process</span>
            <span className="c3">
              &quot; means to take any action or perform any operation or set of
              operations that the Services are capable of taking or performing
              on any data, information, or other content, including to collect,
              receive, input, upload, download, record, reproduce, store,
              organize, compile, combine, log, catalog, cross-reference, manage,
              maintain, copy, adapt, alter, translate, or make other derivative
              works or improvements, process, retrieve, output, consult, use,
              perform, display, disseminate, transmit, submit, post, transfer,
              disclose, or otherwise provide or make available, or block, erase,
              or destroy. &ldquo;Processing&rdquo; and &ldquo;Processed&rdquo;
              have correlative meanings.
            </span>
          </li>
          <li className="c1">
            <span className="c3">&quot;</span>
            <span className="c6 c4">FirstLine Social Disabling Device</span>
            <span className="c3">
              &quot; means any software, hardware, or other technology, device,
              or means (including any back d
            </span>
            <a id="id.4d34og8" />
            <span className="c3">
              oor, time bomb, time out, drop dead device, software routine, or
              other disabling device) used by FirstLine Social or its designee
              to disable Customer&rsquo;s or any Authorized User&rsquo;s access
              to or use of the Services automatically with the passage of time
              or under the positive control of FirstLine Social or its designee.
            </span>
          </li>
          <li className="c1">
            <span className="c3">&quot;</span>
            <span className="c6 c4">FirstLine Social Materials</span>
            <span className="c3">
              &quot; means the Services, Specifications, Documentation, and
              FirstLine Social Systems and any and all other information, data,
              documents, materials, works, and other content, devices, methods,
              processes, hardware, software, and other technologies and
              inventions, including any deliverables, technical or functional
              descriptions, requirements, plans, or reports, that are provided
              or used by FirstLine Social or any Subcontractor in connection
              with the Services or otherwise comprise or relate to the Services
              or FirstLine Social Systems. For the avoidance of doubt, FirstLine
              Social Materials include Resultant Data and any information, data,
              or other content derived from FirstLine Social&rsquo;s monitoring
              of Customer&rsquo;s access to or use of the Services, but do not
              include Customer Data.
            </span>
          </li>
          <li className="c1">
            <span className="c3">&quot;</span>
            <span className="c6 c4">FirstLine Social Personnel</span>
            <span className="c3">
              &quot; means all individuals involved in the performance of
              Services as employees, agents, or independent contractors of
              FirstLine Social or any Subcontractor.
            </span>
          </li>
          <li className="c1">
            <span className="c3">&quot;</span>
            <span className="c6 c4">FirstLine Social Systems</span>
            <span className="c3">
              &quot; means the information technology infrastructure used by or
              on behalf of FirstLine Social in performing the Services,
              including all computers, software, hardware, databases, electronic
              systems (including database management systems), and networks,
              whether operated directly by FirstLine Social or through the use
              of third-party services.
            </span>
          </li>
          <li className="c1">
            <span className="c3">&quot;</span>
            <span className="c6 c4">Resultant Data</span>
            <span className="c3">
              &quot; means data and information related to Customer&rsquo;s use
              of the Services that is used by FirstLine Social in an aggregate
              and anonymized manner, including to compile statistical and
              performance information related to the provision and operation of
              the Services.
            </span>
          </li>
          <li className="c1">
            <span className="c3">&quot;</span>
            <span className="c6 c4">Services</span>
            <span className="c3">&quot; means</span>
            <a id="id.2s8eyo1" />
            <span className="c3">
              &nbsp;downloadable or online non-downloadable software platform
              and program accessed via a cloud-based internet portal available
              at{" "}
            </span>
            <span className="c3">
              <a
                className="c9"
                href="https://www.google.com/url?q=http://www.firstlinesocial.com&amp;sa=D&amp;ust=1589216643030000"
              >
                www.firstlinesocial.com
              </a>
            </span>
            <span className="c3">
              &nbsp;or the subdomain address FirstLine Social to provides to
              Customer and accessible via a mobile device including, but not
              limited to phone and tablet.{" "}
            </span>
          </li>
          <li className="c1">
            <span className="c3">&ldquo;</span>
            <span className="c6 c4">Third-Party Materials</span>
            <span className="c3">
              &rdquo; means materials and information, in any form or medium,
              including any software, documents, data, content, specifications,
              products, equipment, or components of or relating to the Services
              that are not proprietary to FirstLine Social.
            </span>
          </li>
          <li className="c1">
            <span className="c3">&ldquo;</span>
            <span className="c6 c4">User Generated Content</span>
            <span className="c3">
              &rdquo; means photographs, videos, text, and other media uploaded
              to by Authorized Users to the Services for purposes of submitting
              social media recommendations to the Customer for the
              Customer&rsquo;s review, revision, and approval or rejection.{" "}
            </span>
            <a id="id.17dp8vu" />
          </li>
        </ol>
        <ol className="c5 lst-kix_list_20-0" start="2">
          <li className="c0">
            <span className="c6 c4">Services</span>
            <span className="c3">.</span>
          </li>
        </ol>
        <ol className="c5 lst-kix_list_20-1 start" start="1">
          <li className="c1">
            <span className="c6 c4">Access and Use</span>
            <span className="c3">. </span>
          </li>
        </ol>
        <ol className="c5 lst-kix_list_20-2 start" start="1">
          <li className="c8">
            <span className="c3">
              Subject to and conditioned on Customer&#39;s and its Authorized
              Users&#39; compliance with the terms and conditions of this
              Agreement, FirstLine Social hereby grants Customer a non-excl
            </span>
            <a id="id.3rdcrjn" />
            <span className="c3">
              usive, non-transferable (except in compliance with Section 15.8)
              right to access and use the Services during the Term, solely for
              use by Authorized Users in accordance with the terms and
              conditions herein. Such use is limited to Customer&#39;s internal
              use. FirstLine Social shall provide to Customer the Access
              Credentials within a reasonable time following the Effective Date.
              The number of Authorized Users is disclosed by Customer when You
              tell us the number of persons in your organization upon requesting
              and purchasing Our Services.
            </span>
          </li>
          <li className="c8">
            <span className="c3">
              The originating Customer personnel who agrees to these Terms to
              and accesses our Services on behalf of the Customer is the &ldquo;
            </span>
            <span className="c6 c4">Account Originator</span>
            <span className="c3">
              .&rdquo; The Account Originator must provide its first name, last
              name, company name, email address, and mailing address in order to
              purchase and access Our Services. Unless Costumer provides us with
              prompt written notice including different contact information, we
              will send notifications regarding our Services to the Account
              Originator.
            </span>
          </li>
          <li className="c8">
            <span className="c6 c4">Administration</span>
            <span className="c3">
              . Customer shall appoint, and maintain throughout the Term, a
              Person who is responsible for administering accounts of all
              Authorized Users (&ldquo;
            </span>
            <span className="c6 c4">Administrator</span>
            <span className="c3">
              &rdquo;). The Administrator shall serve as Customer&rsquo;s
              primary point of contact for day-to-day communications,
              consultation, and decision-making regarding this Agreement.{" "}
            </span>
            <span className="c6 c4">
              The Account Originator is presumed to be Customer&rsquo;s
              Administrator.
            </span>
            <span className="c3">
              &nbsp;If the Account Originator is not the Administrator, Customer
              is solely responsible for providing FirstLine Social with prompt
              written notice of the Administrator&rsquo;s first name, last name,
              email address, and mailing address. The Administrator shall be
              responsible for providing all day-to-day consents and approvals on
              behalf of Customer under this Agreement. Customer shall ensure its
              Administrator has the requisite organizational authority, skill,
              experience, and other qualifications to perform in such capacity.
              Customer shall use commercially reasonable efforts to maintain the
              same Administrator in place throughout the Term. If
              Customer&rsquo;s Administrator ceases to be employed by Customer
              or otherwise wishes to replace its Administrator, Customer shall
              promptly name a new Administrator by written notice to FirstLine
              Social.
            </span>
          </li>
          <li className="c8">
            <span className="c3">
              The Administrator can remove access to the Services for any
              Authorized User. The Administrator can also prohibit an Authorized
              User from uploading User Generated Content.{" "}
            </span>
          </li>
          <li className="c8">
            <span className="c3">
              Customer shall also appoint a Person who is responsible for
              reviewing and approving all User Generated Content (&ldquo;
            </span>
            <span className="c6 c4">Moderato</span>
            <span className="c3">
              r&rdquo;). When an Authorized User uploads User Generated Content
              to the Services, the Moderator shall have seven (7) days to access
              and review the User Generated Content (&ldquo;
            </span>
            <span className="c6 c4">Approval Period</span>
            <span className="c3">
              &rdquo;). At the end of the Approval Period, the User Generated
              Content is automatically deleted and no longer accessible by
              Customer or its Affiliates. The Moderator is responsible for
              accessing and reviewing User Generated Content.
            </span>
          </li>
          <li className="c8">
            <span className="c3">
              User Generated Content that is approved by the Moderator (&ldquo;
            </span>
            <span className="c6 c4">Approved Content</span>
            <span className="c3">
              &rdquo;) may be copied and saved by the Customer to a storage
              site, server, or other platform owned and operated by the
              Customer. FirstLine Social is not responsible for any User
              Generated Content or Approved Content that Customer copies and
              reproduces from the Services.{" "}
            </span>
          </li>
        </ol>
        <ol className="c5 lst-kix_list_20-1" start="2">
          <li className="c1">
            <span className="c6 c4">Documentation License</span>
            <span className="c3">
              . FirstLine Social hereby grants to Customer a non-exclusive,
              non-sublicensable, non-transferable (except in compliance with
              Section 15.8) license to use the Documentation during the Term
              solely for Customer&#39;s internal business purposes in connection
              with its use of the Services.
            </span>
          </li>
          <li className="c1">
            <span className="c6 c4">Service and System Control</span>
            <span className="c3">
              . Except as otherwise expressly provided in this Agreement, as
              between the parties:
            </span>
          </li>
        </ol>
        <ol className="c5 lst-kix_list_20-2 start" start="1">
          <li className="c8">
            <span className="c3">
              FirstLine Social has and will retain sole control over the
              operation, provision, maintenance, and management of the FirstLine
              Social Materials; and
            </span>
          </li>
          <li className="c8">
            <span className="c3">
              Customer has and will retain sole control over the operation,
              maintenance, and management of, and all access to and use of, the
              Customer Systems, and sole responsibility for all access to and
              use of the FirstLine Social Materials by any Person by or through
              the Customer Systems or any other means controlled by Customer or
              any Authorized User, including any: (i) information, instructions,
              or materials provided by any of them to the Services or FirstLine
              Social; (ii) results obtained from any use of the Services or
              FirstLine Social Materials; and (iii) conclusions, decisions, or
              actions based on such use.{" "}
            </span>
            <a id="id.26in1rg" />
            <span className="c3">
              To this end, Customer is responsible for administering Authorized
              User accounts and is responsible for the collection and use of any
              data submitted, provided, or uploaded to or through the Services
              including, but not limited to personally identifiable information
              and User Generated Content.{" "}
            </span>
          </li>
          <li className="c8">
            <span className="c3">
              FirstLine Social does not control the User Generated Content. All
              User Generated Content uploaded during the Approval Period
              temporarily resides on secure servers controlled by third parties.
              FirstLine Social disclaims all liability with respect to the User
              Generated Content and Approved Content.{" "}
            </span>
          </li>
        </ol>
        <ol className="c5 lst-kix_list_20-1" start="4">
          <li className="c1">
            <span className="c6 c4">Reservation of Rights</span>
            <span className="c3">
              . Nothing in this Agreement grants any right, title, or interest
              in or to (including any license under) any Intellectual Property
              Rights in or relating to, the Services, FirstLine Social
              Materials, or Third-Party Materials, whether expressly, by
              implication, estoppel, or otherwise. All right, title, and
              interest in and to the Services, the FirstLine Social Materials,
              and the Third-Party Materials are and will remain with FirstLine
              Social and the respective rights holders in the Third-Party
              Materials.
            </span>
          </li>
          <li className="c1">
            <span className="c6 c4">Changes</span>
            <span className="c3">
              . FirstLine Social reserves the right, in its sole discretion, to
              make any changes to the Services and FirstLine Social Materials
              that it deems necessary or useful to: (a) maintain or enhance: (i)
              the quality or delivery of the Services to its customers; (ii) the
              competitive strength of or market for the Services; or (iii) the
              Services&#39; cost efficiency or performance; or (b) to comply
              with applicable Law. Without limiting the foregoing, either party
              may, at any time during the Term, request in writing changes to
              the Services.{" "}
            </span>
            <a id="id.lnxbz9" />
          </li>
          <li className="c1">
            <span className="c6 c4">Subcontractors.</span>
            <span className="c3">
              &nbsp;FirstLine Social may from time to time in its discretion
              engage third parties to perform Services (each, a
              &quot;Subcontractor&quot;).{" "}
            </span>
          </li>
          <li className="c1">
            <span className="c6 c4">Suspension or Termination of Services</span>
            <span className="c3">
              . FirstLine Social may, directly or indirectly, and by use of a
              FirstLine Social Disabling Device or any other lawful means,
              suspend, terminate, or otherwise deny Customer&#39;s, any
              Authorized User&#39;s, or any other Person&#39;s access to or use
              of all or any part of the Services or FirstLine Social Materials,
              without incurring any resulting obligation or liability, if: (a)
              FirstLine Social receives a judicial or other governmental demand
              or order, subpoena, or law enforcement request that expressly or
              by reasonable implication requires FirstLine Social to do so; or
              (b) FirstLine Social believes, in its discretion, that: (i)
              Customer or any Authorized User has failed to comply with any term
              of this Agreement, or accessed or used the Services beyond the
              scope of the rights granted or for a purpose not authorized under
              this Agreement or in any manner that does not comply with any
              &nbsp;instruction or requirement of the Specifications; (ii)
              Customer or any Authorized User is, has been, or is likely to be
              involved in any fraudulent, misleading, or unlawful activities; or
              (iii) this Agreement expires or is terminated. This Section 2.8
              does not limit any of FirstLine Social&#39;s other rights or
              remedies, whether at law, in equity, or under this Agreement.
            </span>
          </li>
        </ol>
        <ol className="c5 lst-kix_list_20-0" start="3">
          <li className="c0">
            <span className="c6 c4">
              Use Restrictions; Service Usage and Data Storage
            </span>
            <span className="c3">. </span>
          </li>
        </ol>
        <ol className="c5 lst-kix_list_20-1 start" start="1">
          <li className="c1">
            <span className="c6 c4">Use Restrictions</span>
            <span className="c3">
              . Customer shall not, and shall not permit any other Person and/or
              Authorized User to, access or use the Services or FirstLine Social
              Materials except as expressly permitted by this Agreement and, in
              the case of Third-Party Materials, the applicable third-party
              license agreement. For purposes of clarity and without limiting
              the generality of the foregoing, Customer shall not, and shall not
              permit any other Person and/or Authorized User, except as this
              Agreement expressly permits:
            </span>
          </li>
        </ol>
        <ol className="c5 lst-kix_list_20-2 start" start="1">
          <li className="c8">
            <span className="c3">
              copy, modify, or create derivative works or improvements of the
              Services or FirstLine Social Materials;
            </span>
          </li>
          <li className="c8">
            <span className="c3">
              rent, lease, lend, sell, sublicense, assign, distribute, publish,
              transfer, or otherwise make available any Services or FirstLine
              Social Materials to any Person, including on or in connection with
              the internet or any time-sharing, service bureau, software as a
              service, cloud, or other technology or service;
            </span>
          </li>
          <li className="c8">
            <span className="c3">
              reverse engineer, disassemble, decompile, decode, adapt, or
              otherwise attempt to derive or gain access to the source code of
              the Services or FirstLine Social Materials, in whole or in part;
            </span>
          </li>
          <li className="c8">
            <span className="c3">
              bypass or breach any security device or protection used by the
              Services or FirstLine Social Materials or access or use the
              Services or FirstLine Social Materials other than by an Authorized
              User through the use of his or her own then valid Access
              Credentials;
            </span>
            <a id="id.35nkun2" />
          </li>
          <li className="c8">
            <span className="c3">
              input, upload, transmit, or otherwise provide to or through the
              Services or FirstLine Social Systems, any information or materials
              that are unlawful or injurious, or contain, transmit, or activate
              any Harmful Code;
            </span>
          </li>
          <li className="c8">
            <span className="c3">
              damage, destroy, disrupt, disable, impair, interfere with, or
              otherwise impede or harm in any manner the Services, FirstLine
              Social Systems, or FirstLine Social&#39;s provision of services to
              any third party, in whole or in part;
            </span>
          </li>
          <li className="c8">
            <span className="c3">
              remove, delete, alter, or obscure any trademarks, Specifications,
              Documentation, warranties, or disclaimers, or any copyright,
              trademark, patent, or other intellectual property or proprietary
              rights notices from any Services or FirstLine Social Materials,
              including any copy thereof;
            </span>
          </li>
          <li className="c8">
            <span className="c3">
              access or use the Services or FirstLine Social Materials in any
              manner or for any purpose that infringes, misappropriates, or
              otherwise violates any Intellectual Property Right or other right
              of any third party (including by any unauthorized access to,
              misappropriation, use, alteration, destruction, or disclosure of
              the data of any other FirstLine Social customer), or that violates
              any applicable Law;
            </span>
          </li>
          <li className="c8">
            <span className="c3">
              access or use the Services or FirstLine Social Materials for
              purposes of competitive analysis of the Services or FirstLine
              Social Materials, the development, provision, or use of a
              competing software service or product or any other purpose that is
              to the FirstLine Social&#39;s detriment or commercial
              disadvantage; or
            </span>
          </li>
          <li className="c8">
            <span className="c3">
              access or use the Services or FirstLine Social Materials in, or in
              association with, the design, construction, maintenance, or
              operation of any hazardous environments, systems, or applications,
              any safety response systems or other safety-critical applications,
              or any other use or application in which the use or failure of the
              Services could lead to personal injury or severe physical or
              property damage;{" "}
            </span>
          </li>
          <li className="c8">
            <span className="c3">
              access or use the Services to bully, harass, intimidate, or defame
              another Person;
            </span>
          </li>
          <li className="c8">
            <span className="c3">
              allow Authorized Users to copy, archive, download, distribute,
              syndicate, broadcast, publicly perform, publicly display, make
              available, or otherwise use any of the User Generated Content of
              Approved Content;{" "}
            </span>
          </li>
          <li className="c8">
            <span className="c3">
              submit User Generated Content deemed to be evidentiary to a civil
              or criminal legal proceeding; or
            </span>
          </li>
          <li className="c8">
            <span className="c3">
              otherwise access or use the Services or FirstLine Social Materials
              beyond the scope of the authorization granted under this Section
              3.1.{" "}
            </span>
          </li>
        </ol>
        <ol className="c5 lst-kix_list_20-0" start="4">
          <li className="c0">
            <span className="c6 c4">Customer Obligations</span>
            <span className="c3">.</span>
          </li>
        </ol>
        <ol className="c5 lst-kix_list_20-1 start" start="1">
          <li className="c1">
            <span className="c6 c4">Customer Systems and Cooperation</span>
            <span className="c3">
              . Customer shall at all times during the Term: (a) set up,
              maintain, and operate in good repair and in accordance with the
              Specifications all Customer Systems on or through which the
              Services are accessed or used; (b) provide FirstLine Social
              Personnel with such access to Customer&#39;s premises and Customer
              Systems as is necessary for FirstLine Social to perform the
              Services in accordance with the Availability Requirement and
              Specifications; and (c) provide all cooperation and assistance as
              FirstLine Social may reasonably request to enable FirstLine Social
              to exercise its rights and perform its obligations under and in
              connection with this Agreement.
            </span>
          </li>
          <li className="c1">
            <span className="c6 c4">Effect of Customer Failure or Delay.</span>
            <span className="c3">
              &nbsp;FirstLine Social is not responsible or liable for any delay
              or failure of performance caused in whole or in part by
              Customer&#39;s delay in performing, or failure to perform, any of
              its obligations under this Agreement (each, a &quot;Customer
              Failure&quot;).{" "}
            </span>
          </li>
          <li className="c1">
            <span className="c6 c4">Corrective Action and Notice</span>
            <span className="c3">
              . If Customer becomes aware of any actual or threatened activity
              prohibited by Section 3.1, Customer shall, and shall cause its
              Authorized Users to, immediately: (a) take all reasonable and
              lawful measures within their respective control that are necessary
              to stop the activity or threatened activity and to mitigate its
              effects (including, where applicable, by discontinuing and
              preventing any unauthorized access to the Services and FirstLine
              Social Materials and permanently erasing from their systems and
              destroying any data to which any of them have gained unauthorized
              access); and (b) notify FirstLine Social of any such actual or
              threatened activity.{" "}
            </span>
          </li>
        </ol>
        <ol className="c5 lst-kix_list_20-0" start="5">
          <li className="c0">
            <span className="c6 c4">Service Levels and Credits</span>
            <span className="c3">.</span>
          </li>
        </ol>
        <ol className="c5 lst-kix_list_20-1 start" start="1">
          <li className="c1">
            <span className="c6 c4">Service Levels</span>
            <span className="c3">
              . Subject to the terms and conditions of this Agreement, FirstLine
              Social will use commercially reasonable efforts to make the
              Services Available at least ninety-nine percent (99%) of the time
              as measured over the course of each calendar month during the Term
              (each such calendar month, a &quot;
            </span>
            <span className="c6 c4">Service Period</span>
            <span className="c3">
              &quot;), excluding unavailability as a result of any of the
              Exceptions described below in this Section 5.1 (the &quot;
            </span>
            <span className="c6 c4">Availability Requirement</span>
            <span className="c3">&quot;). &quot;</span>
            <span className="c6 c4">Service Level Failure</span>
            <span className="c3">
              &quot; means a material failure of the Services to meet the
              Availability Requirement. &quot;
            </span>
            <span className="c6 c4">Available</span>
            <span className="c3">
              &quot; means the Services are available for access and use by
              Customer and its Authorized Users over the Internet and operating
              in material accordance with the Specifications. For purposes of
              calculating the Availability Requirement, the following are
              &quot;Exceptions&quot; to the Availability Requirement, and
              neither the Services will be considered un-Available nor any
              Service Level Failure be deemed to occur in connection with any
              failure to meet the Availability Requirement or impaired ability
              of Customer or its Authorized Users to access or use the Services
              that is due, in whole or in part, to any: (a) act or omission by
              Customer or any Authorized User/access to or use of the Services
              by Customer or any Authorized User, or using Customer&#39;s or an
              Authorized User&#39;s Access Credentials, that does not strictly
              comply with this Agreement and the Specifications; (b) Customer
              Failure; (c) Customer&#39;s or its Authorized User&#39;s Internet
              connectivity; (d) Force Majeure Event; (e) failure, interruption,
              outage, or other problem with any software, hardware, system,
              network, facility, or other matter not supplied by FirstLine
              Social pursuant to this Agreement; (f) Scheduled Downtime; or (g)
              disabling, suspension, or termination of the Services pursuant to
              Section 2.8.
            </span>
          </li>
          <li className="c1">
            <span className="c6 c4">Service Level Failures and Remedies</span>
            <span className="c3">
              . In the event of a Service Level Failure, FirstLine Social shall
              issue a credit to Customer in the amount of twenty-five percent
              (25 %) of the monthly Fees for the Services due for the Service
              Period the Service Level Failure occurred (each a &quot;Service
              Credit&quot;), subject to the following:{" "}
            </span>
          </li>
        </ol>
        <ol className="c5 lst-kix_list_20-2 start" start="1">
          <li className="c8">
            <span className="c3">
              FirstLine Social has no obligation to issue any Service Credit
              unless: (i) Customer reports the Service Failure to FirstLine
              Social immediately on becoming aware of it; and (ii) requests such
              Service Credit in writing within three (3) days of the Service
              Level Failure; and
            </span>
          </li>
          <li className="c8">
            <span className="c3">
              in no event will a Service Level Credit for any Service Period
              exceed one-hundred (100) percent of the total Fees that would be
              payable for that Service Period if no Service Level Failure had
              occurr
            </span>
            <a id="id.1ksv4uv" />
            <span className="c3">ed.</span>
          </li>
        </ol>
        <p className="c10">
          <span className="c3">
            Any Service Credit payable to Customer under this Agreement will be
            issued to Customer in the calendar month following the Service
            Period in which the Service Level Failure occurred. This Section 5.2
            sets forth FirstLine Social&#39;s sole obligation and liability and
            Customer&#39;s sole remedy for any Service Level Failure.
          </span>
        </p>
        <ol className="c5 lst-kix_list_20-1" start="3">
          <li className="c1">
            <span className="c6 c4">Scheduled Downtime</span>
            <span className="c3">
              . FirstLine Social will use commercially reasonable efforts to:
              (a) schedule downtime for routine maintenance of the Services
              between the hours of 0100 and 0300 Easter Time; and (b) give
              Customer at least twelve (12) hours prior notice of all scheduled
              outages of the Services (&quot;Scheduled Downtime&quot;).
            </span>
          </li>
        </ol>
        <ol className="c5 lst-kix_list_20-0" start="6">
          <li className="c0">
            <span className="c6 c4">Data Backup</span>
            <span className="c3">
              . The Services do not replace the need for Customer to maintain
              regular data backups or redundant data archives. FIRSTLINE SOCIAL
              HAS NO OBLIGATION OR LIABILITY FOR ANY LOSS, ALTERATION,
              DESTRUCTION, DAMAGE, CORRUPTION, OR RECOVERY OF CUSTOMER DATA.
            </span>
          </li>
          <li className="c0">
            <span className="c6 c4">Security</span>
            <span className="c3">. </span>
          </li>
        </ol>
        <ol className="c5 lst-kix_list_20-1 start" start="1">
          <li className="c1">
            <span className="c6 c4">Information Security</span>
            <span className="c3">
              . FirstLine Social will employ security measures in accordance
              with FirstLine Social&#39;s data privacy and security policy.
            </span>
          </li>
          <li className="c1">
            <span className="c6 c4">Data Breach Procedures</span>
            <span className="c3">
              . FirstLine Social maintains a data breach plan and shall
              implement the procedures required under such data breach plan on
              the occurrence of a data b
            </span>
            <a id="id.44sinio" />
            <span className="c3">reach (as defined in such plan).</span>
          </li>
          <li className="c1">
            <span className="c6 c4">Customer Control and Responsibility</span>
            <span className="c3">
              . Customer has and will retain sole responsibility for: (a) all
              Customer Data, User Generated Content, and Approved Content
              including its content and use; (b) all information, instructions,
              and materials provided by or on behalf of Customer or any
              Authorized User in connection with the Services; (c)
              Customer&#39;s information technology infrastructure, including
              computers, software, databases, electronic systems (including
              database management systems), and networks, whether operated
              directly by Customer or through the use of third-party services
              (&quot;Customer Systems&quot;); (d) the security and use of
              Customer&#39;s and its Authorized Users&#39; Access Credentials;
              and (e) all access to and use of the Services and FirstLine Social
              Materials directly or indirectly by or through the Customer
              Systems or its or its Authorized Users&#39; Access Credentials,
              with or without Customer&#39;s knowledge or consent, including all
              results obtained from, and all conclusions, decisions, and actions
              based on, such access or use.
            </span>
          </li>
          <li className="c1">
            <span className="c6 c4">Access and Security</span>
            <span className="c3">
              . Customer shall employ all physical, administrative, and
              technical controls, screening, and security procedures and other
              safeguards necessary to: (a) securely administer the distribution
              and use of all Access Credentials and protect against any
              unauthorized access to or use of the Services; and (b) control the
              content and use of C
            </span>
            <a id="id.2jxsxqh" />
            <span className="c3">
              ustomer Data, including the uploading or other provision of
              Customer Data for Processing by the Services.
            </span>
          </li>
        </ol>
        <ol className="c5 lst-kix_list_20-0" start="8">
          <li className="c0">
            <span className="c6 c4 c11">Fees and Payment</span>
            <a id="id.z337ya" />
            <span className="c3">. </span>
          </li>
        </ol>
        <ol className="c5 lst-kix_list_20-1 start" start="1">
          <li className="c1">
            <span className="c6 c4">Fees</span>
            <span className="c3">
              . Customer shall pay FirstLine Social the fees (&quot;
            </span>
            <span className="c6 c4">Fees</span>
            <span className="c3">
              &quot;) as agreed to upon purchasing FirstLine Social Services
              without offset or deduction. Fees are determined by the number of
              employees by Customers or the number of members in
              Customer&rsquo;s organization as disclosed to FirstLine Social by
              Customer. Customer shall make all payments hereunder in US dollars
              upon or before accessing the Services. If Customer&rsquo;s payment
              of the Fees cannot be processed by FirstLine Social, We may
              prohibit or suspend Your access to{" "}
            </span>
            <a id="id.3j2qqm3" />
            <span className="c3">Our Services.</span>
          </li>
          <li className="c1">
            <span className="c6 c4">Taxes</span>
            <span className="c3">
              . All Fees and other amounts payable by Customer under this
              Agreement are exclusive of taxes and similar assessments. Customer
              are responsible for all sales, use, and excise taxes, and any
              other similar taxes, duties, and charges of any kind imposed by
              any federal, state, or local governmental or regulatory authority
              on any amounts payable by Customer hereunder, other than any taxes
              imposed on FirstLine Social
            </span>
            <a id="id.1y810tw" />
            <span className="c3">&#39;s income.</span>
          </li>
          <li className="c2 c19">
            <span className="c4">Payments</span>
            <span className="c3">
              . To access our Services and pay the Fees, Customer must provide
              Us with a valid credit card or other form of electronic payment
              (such as PayPal). We will automatically charge You on the same day
              You choose to access our Services. We will share your account
              information with financial institutions and payment processing
              companies, namely, Stripe, Inc., including your submitted payment
              information, to process your purchase. We do not support all
              payment methods, currencies or locations for payment of Fees. If
              the payment method Customer uses is no longer valid (such as a
              credit card that has expired) and Customer does not edit its
              payment information or cancel Services, you authorize us to keep
              billing you for our Services and you remain responsible for
              uncollected amounts. If you owe us any unpaid Fees, we may suspend
              your access to our Services without prior notice until You pay us
              in full. Your obligation to pay fees continues through to the end
              of the period in which you cancel your Services.{" "}
            </span>
          </li>
          <li className="c17">
            <span className="c4">No Refunds</span>
            <span className="c13">. Fees </span>
            <a id="id.4i7ojhp" />
            <span className="c3">payable are non-refundable. </span>
          </li>
        </ol>
        <ol className="c5 lst-kix_list_20-0" start="9">
          <li className="c0">
            <span className="c6 c4 c11">Confidential Information</span>
            <span className="c3">
              . From time to time during the Term, either Party may disclose or
              make available to the other Party information about its business
              affairs, products, confidential intellectual property, trade
              secrets, third-party confidential information, and other sensitive
              or proprietary information, whether orally or in written,
              electronic, or other form or media/in written or electronic form
              or media, &nbsp;whether or not marked, designated, or otherwise
              identified as &quot;confidential&quot; (collectively, &quot;
            </span>
            <span className="c6 c4">Confidential Information</span>
            <span className="c3">
              &quot;). Confidential Information does not include information
              that, at the time of disclosure is: (a) in the public domain; (b)
              known to the receiving Party at the time of disclosure; (c)
              rightfully obtained by the receiving Party on a non-confidential
              basis from a third party; or (d) independently developed by the
              receiving Party. The receiving Party shall not disclose the
              disclosing Party&#39;s Confidential Information to any Person or
              entity, except to the receiving Party&#39;s employees who have a
              need to know the Confidential Information for the receiving Party
              to exercise its rights or perform its obligations hereunder.
              Notwithstanding the foregoing, each Party may disclose
              Confidential Information to the limited extent required (i) in
              order to comply with the order of a court or other governmental
              body, or as otherwise necessary to comply with applicable law,
              provided that the Party making the disclosure pursuant to the
              order shall first have given written notice to the other Party and
              made a reasonable effort to obtain a protective order; or (ii) to
              establish a Party&#39;s rights under this Agreement, including to
              make required court filings. On the expiration or termination of
              the Agreement, the receiving Party shall promptly return to the
              disclosing Party all copies, whether in written, electronic, or
              other form or media, of the disclosing Party&#39;s Confidential
              Information, or destroy all such copies and certify in writing to
              the disclosing Party that such Confidential Information has been
              destroyed. Each Party&#39;s obligations of non-disclosure with
              regard to Confidential Information are effective as of the
              Effective Date and will expire five years from the date first
              disclosed to the receiving Party; provided, however, with respect
              to any Confidential Information that constitutes a trade secret
              (as determined under applicable law), such obligations of
              non-disclosure will survive the termination or expiration of this
              Agreement for as long as such Confidential Information remains
              subject to trade secret protection under applicable law.
            </span>
            <a id="id.2xcytpi" />
          </li>
          <li className="c0">
            <span className="c6 c4">
              Intellectual Property Ownership; Feedback
            </span>
            <a id="id.1ci93xb" />
            <span className="c3">. </span>
          </li>
        </ol>
        <a id="id.3whwml4" />
        <ol className="c5 lst-kix_list_20-1" start="5">
          <li className="c1">
            <span className="c6 c4">FirstLine Social IP</span>
            <span className="c3">
              . Customer acknowledge that, as between Customer and FirstLine
              Social, FirstLine Social owns all right, title, and interest,
              including all intellectual property rights, in and to the
              FirstLine Social IP.
            </span>
            <a id="id.2bn6wsx" />
            <span className="c3">&nbsp;</span>
          </li>
          <li className="c1">
            <span className="c6 c4">Customer Data</span>
            <span className="c3">
              . FirstLine Social acknowledges that, as between FirstLine Social
              and Customer, Customer own all right, title, and interest,
              including all intellectual property rights, in and to the Customer
              Data. Customer hereby grants to FirstLine Social a non-exclusive,
              royalty-free, worldwide license to reproduce, distribute, and
              otherwise use and display Your Data and perform all acts with
              respect to the Your Data as may be necessary for FirstLine Social
              to provide the Services to Customer, and a non-exclusive,
              perpetual, irrevocable, royalty-free, worldwide license to
              reproduce, distribute, modify, and otherwise use and display You
              Data incorporated within the Aggregated Statistics
            </span>
            <a id="id.qsh70q" />
            <span className="c3">.</span>
          </li>
          <li className="c1">
            <span className="c6 c4">Feedback</span>
            <span className="c3">
              . If Customer or any of your employees or contractors sends or
              transmits any communications or materials to FirstLine Social by
              mail, email, telephone, or otherwise, suggesting or recommending
              changes to the FirstLine Social IP, including without limitation,
              new features or functionality relating thereto, or any comments,
              questions, suggestions, or the like (&quot;
            </span>
            <span className="c6 c4">Feedback</span>
            <span className="c3">
              &quot;), FirstLine Social is free to use such Feedback
              irrespective of any other obligation or limitation between the
              Parties governing such Feedback. Customer hereby assigns to
              FirstLine Social on Your behalf, and on behalf of your employees,
              contractors and/or agents, all right, title, and interest in, and
              FirstLine Social is free to use, without any attribution or
              compensation to any party, any ideas, know-how, concepts,
              techniques, or other intellectual property rights contained in the
              Feedback, for any purpose whatsoever, although FirstLine Social
            </span>
            <a id="id.3as4poj" />
            <span className="c3">
              &nbsp;is not required to use any Feedback.
            </span>
          </li>
        </ol>
        <ol className="c5 lst-kix_list_20-0" start="11">
          <li className="c0">
            <span className="c6 c4">Warranty Disclaimer</span>
            <a id="id.1pxezwc" />
            <span className="c3">
              . THE FIRSTLINE SOCIAL IP IS PROVIDED &quot;AS IS&quot; AND
              FIRSTLINE SOCIAL HEREBY DISCLAIMS ALL WARRANTIES, WHETHER EXPRESS,
              IMPLIED, STATUTORY, OR OTHERWISE. FIRSTLINE SOCIAL SPECIFICALLY
              DISCLAIMS ALL IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
              PARTICULAR PURPOSE, TITLE, AND NON-INFRINGEMENT, AND ALL
              WARRANTIES ARISING FROM COURSE OF DEALING, USAGE, OR TRADE
              PRACTICE. FIRSTLINE SOCIAL MAKES NO WARRANTY OF ANY KIND THAT THE
              FIRSTLINE SOCIAL IP, OR ANY PRODUCTS OR RESULTS OF THE USE
              THEREOF, WILL MEET CUSTOMER&#39;S OR ANY OTHER PERSON&#39;S
              REQUIREMENTS, OPERATE WITHOUT INTERRUPTION, ACHIEVE ANY INTENDED
              RESULT, BE COMPATIBLE OR WORK WITH ANY SOFTWARE, SYSTEM, OR OTHER
              SERVICES, OR BE SECURE, ACCURATE, COMPLETE, FREE OF HARMFUL CODE,
              OR ERROR FREE.{" "}
            </span>
            <a id="id.49x2ik5" />
          </li>
          <li className="c0">
            <span className="c6 c4 c11">Indemnification</span>
            <a id="id.2p2csry" />
            <span className="c3">. </span>
          </li>
        </ol>
        <ol className="c5 lst-kix_list_20-1 start" start="1">
          <li className="c1">
            <span className="c6 c4">FirstLine Social Indemnification</span>
            <a id="id.147n2zr" />
            <span className="c3">. </span>
          </li>
        </ol>
        <ol className="c5 lst-kix_list_20-2 start" start="1">
          <li className="c8">
            <span className="c3">
              FirstLine Social shall indemnify, defend, and hold harmless
              Customer from and against any and all losses, damages,
              liabilities, costs (&quot;
            </span>
            <span className="c6 c4">Losses</span>
            <span className="c3">
              &quot;) incurred by Customer resulting from any third-party claim,
              suit, action, or proceeding (&quot;
            </span>
            <a id="id.3o7alnk" />
            <span className="c6 c4">Third-Party Claim</span>
            <span className="c3">
              &quot;) that the Services, or any use of the Services in
              accordance with this Agreement, infringes or misappropriates such
              third party&#39;s US intellectual property rights, provided that
              Customer promptly notify FirstLine Social in writing of the claim,
              cooperates with FirstLine Social, and allows FirstLine Social sole
              authority to control the
            </span>
            <a id="id.23ckvvd" />
            <span className="c3">
              &nbsp;defense and settlement of such claim.{" "}
            </span>
          </li>
          <li className="c8">
            <span className="c3">
              If such a claim is made or appears possible, Customer agree to
              permit FirstLine Social, at FirstLine Social&#39;s sole
              discretion, to (A) modify or replace the Services, or component or
              part thereof, to make it non-infringing, or (B) obtain the right
              for Customer to continue use. If FirstLine Social determines that
              neither alternative is reasonably available, FirstLine Social may
              terminate this Agreement, in its entirety or with respect to the
              affected component or part, effective immediately on written
              notice to Customer
            </span>
            <a id="id.ihv636" />
            <span className="c3">. </span>
          </li>
          <li className="c8">
            <span className="c3">
              This Section 12.1 will not apply to the extent that the alleged
              infringement arises from: (A) use of the Services in combination
              with data, software, hardware, equipment, or technology not
              provided by FirstLine Social or authorized by FirstLine Social in
              writing; (B) modifications to the Services not made by FirstLine
              Social; or (C) Your
            </span>
            <a id="id.32hioqz" />
            <span className="c3">&nbsp;Data.</span>
          </li>
        </ol>
        <ol className="c5 lst-kix_list_20-1" start="2">
          <li className="c1">
            <span className="c6 c4">Customer Indemnification</span>
            <span className="c3">
              . Customer shall indemnify, hold harmless, and, at FirstLine
              Social&#39;s option, defend FirstLine Social from and against any
              Losses resulting from any Third-Party Claim that Customer Data, or
              any use of Customer Data in accordance with this Agreement,
              infringes or misappropriates such third party&#39;s intellectual
              property rights and any Third-Party Claims based on Your or any
              Authorized User&#39;s (i) negligence or willful misconduct; (ii)
              use of the Services in a manner not authorized by this Agreement;
              (iii) use of the Services in combination with data, software,
              hardware, equipment, or technology not provided by FirstLine
              Social or authorized by FirstLine Social in writing; or (iv)
              modifications to the Services not made by FirstLine Social,
              provided that Customer may not settle any Third-Party Claim
              against FirstLine Social unless FirstLine Social consents to such
              settlement, and further provided that FirstLine Social will have
              the right, at its option, to defend itself against any such Th
            </span>
            <a id="id.1hmsyys" />
            <span className="c3">
              ird-Party Claim or to participate in the defense thereof by
              counsel of its own choice.{" "}
            </span>
          </li>
          <li className="c1">
            <span className="c6 c4">Sole Remedy</span>
            <span className="c3">
              . THIS SECTION 12 SETS FORTH CUSTOMER&#39;S SOLE REMEDIES AND
              FIRSTLINE SOCIAL&#39;S SOLE LIABILITY AND OBLIGATION FOR ANY
              ACTUAL, THREATENED, OR ALLEGED CLAIMS THAT THE SERVICES INFRINGE,
              MISAPPROPRIATE, OR OTHERWISE VIOLATE ANY INTELLECTUAL PROPERTY
              RIGHTS OF ANY THIRD PARTY. IN NO EVENT WILL FIRSTLINE SOCIAL&#39;S
              LIABILITY UNDER THIS SECTION 12.1 EXCEED $10,000.{" "}
            </span>
            <a id="id.41mghml" />
          </li>
        </ol>
        <ol className="c5 lst-kix_list_20-0" start="13">
          <li className="c0">
            <span className="c6 c4 c11">Limitations of Liability</span>
            <span className="c3">
              . IN NO EVENT WILL FIRSTLINE SOCIAL BE LIABLE UNDER OR IN
              CONNECTION WITH THIS AGREEMENT UNDER ANY LEGAL OR EQUITABLE
              THEORY, INCLUDING BREACH OF CONTRACT, TORT (INCLUDING NEGLIGENCE),
              STRICT LIABILITY, AND OTHERWISE, FOR ANY: (a) CONSEQUENTIAL,
              INCIDENTAL, INDIRECT, EXEMPLARY, SPECIAL, ENHANCED, OR PUNITIVE
              DAMAGES; (b) INCREASED COSTS, DIMINUTIO
            </span>
            <a id="id.2grqrue" />
            <span className="c3">
              N IN VALUE OR LOST BUSINESS, PRODUCTION, REVENUES, OR PROFITS; (c)
              LOSS OF GOODWILL OR REPUTATION; (d) USE, INABILITY TO USE, LOSS,
              INTERRUPTION, DELAY, OR RECOVERY OF ANY DATA, OR BREACH OF DATA OR
              SYSTEM SECURITY; OR (e) COST OF REPLACEMENT GOODS OR SERVICES, IN
              EACH CASE REGARDLESS OF WHETHER FIRSTLINE SOCIAL WAS ADVISED OF
              THE POSSIBILITY OF SUCH LOSSES OR DAMAGES OR SUCH LOSSES OR
              DAMAGES WERE OTHERWISE FORESEEABLE. IN NO EVENT WILL FIRSTLINE
              SOCIAL&#39;S AGGREGATE LIABILITY ARISING OUT OF OR RELATED TO THIS
              AGREEMENT UNDER ANY LEGAL OR EQUITABLE THEORY, INCLUDING BREACH OF
              CONTRACT, TORT (INCLUDING NEGLIGENCE), STRICT LIABILITY, AND
              OTHERWISE EXCEED THREE (3) TIMES THE TOTAL AMOUNTS PAID AND
              AMOUNTS ACCRUED BUT NOT YET PAID TO FIRSTLINE SOCIAL UNDER THIS
              AGREEMENT IN THE THREE (3) YEAR PERIOD PRECEDING THE EVENT GIVING
              RISE TO THE CLAIM OR $10,000, WHICHEVER IS LESS.
            </span>
            <a id="id.vx1227" />
            <span className="c3">&nbsp;</span>
          </li>
          <li className="c0">
            <span className="c6 c4 c11">Term and Termination</span>
            <a id="id.3fwokq0" />
            <span className="c3">. </span>
          </li>
        </ol>
        <ol className="c5 lst-kix_list_20-1 start" start="1">
          <li className="c1">
            <span className="c6 c4">Term</span>
            <span className="c3">
              . The initial term of this Agreement begins on the Effective Date
              and, unless terminated earlier pursuant to this Agreement&#39;s
              express provisions, will continue in effect until one (1) year
              from such date (the &quot;
            </span>
            <span className="c6 c4">Initial</span>
            <span className="c3">&nbsp;</span>
            <span className="c6 c4">Term</span>
            <span className="c3">
              &quot;). This Agreement will automatically renew for additional
              successive terms. FirstLine Social will automatically charge
              Customer the Fees to renew the Agreement for an additional one (1)
              year (&quot;
            </span>
            <span className="c6 c4">Renewal Term</span>
            <span className="c3">
              &quot; together with the Initial Term, the &quot;
            </span>
            <span className="c6 c4">Term</span>
            <a id="id.1v1yuxt" />
            <span className="c3">&quot;).</span>
          </li>
          <li className="c1">
            <span className="c6 c4">Termination</span>
            <span className="c3">. In addition</span>
            <a id="id.4f1mdlm" />
            <span className="c3">
              &nbsp;to any other express termination right set forth in this
              Agreement:
            </span>
          </li>
        </ol>
        <ol className="c5 lst-kix_list_20-2 start" start="1">
          <li className="c8">
            <span className="c3">
              FirstLine Social may terminate this Agreement, effective on
              written notice to Customer, if Customer: (A) fails to pay any
              amount when due hereunder, and such failure continues more than
              thirty (30) days after FirstLine Social&#39;s delivery of written
              notice thereof; or (B) breach any of Your obligations under
              Section 4 or Section 9
            </span>
            <a id="id.2u6wntf" />
            <span className="c3">;</span>
          </li>
          <li className="c8">
            <span className="c3">
              Either Party may terminate this Agreement, effective on written
              notice to the other Party, if the other Party breaches this
              Agreement, and such breach: (A) is incapable of cure; or (B) being
              capable of cure, remains uncured thirty (30) days after the
              non-breaching Party provides the breaching Party with written
              notice of such br
            </span>
            <a id="id.19c6y18" />
            <span className="c3">each; or</span>
          </li>
          <li className="c8">
            <span className="c3">
              Either Party may terminate this Agreement, effective immediately
              upon written notice to the other Party, if the other Party: (A)
              becomes insolvent or is generally unable to pay, or fails to pay,
              its debts as they become due; (B) files or has filed against it, a
              petition for voluntary or involuntary bankruptcy or otherwise
              becomes subject, voluntarily or involuntarily, to any proceeding
              under any domestic or foreign bankruptcy or insolvency law; (C)
              makes or seeks to make a general assignment for the benefit of its
              creditors; or (D) applies for or has appointed a receiver,
              trustee, custodian, or similar agent appointed by
            </span>
            <a id="id.3tbugp1" />
            <span className="c3">
              &nbsp;order of any court of competent jurisdiction to take charge
              of or sell any mat
            </span>
            <a id="id.28h4qwu" />
            <span className="c3">
              erial portion of its property or business.
            </span>
          </li>
        </ol>
        <ol className="c5 lst-kix_list_20-1" start="3">
          <li className="c1">
            <span className="c6 c4">Effect of Expiration or Termination</span>
            <span className="c3">
              . Upon expiration or earlier termination of this Agreement,
              Customer shall immediately discontinue use of the FirstLine Social
              IP and, without limiting Customer obligations under Section 9,
              Customer shall delete, destroy, or return all copies of the
              FirstLine Social IP and certify in writing to the FirstLine Social
              that the FirstLine Social IP has been deleted or destroyed.{" "}
            </span>
            <span className="c6 c4">
              No expiration or termination will affect Customer&#39;s obligation
              to pay all Fees that may have become due before such expiration or
              termination or entitle Customer
            </span>
            <a id="id.nmf14n" />
            <span className="c6 c4">&nbsp;to any refund.</span>
          </li>
          <li className="c1">
            <span className="c6 c4">Survival</span>
            <span className="c3">
              . This Section 14.4 and Sections 1, 8, 9, 11 8.2, 12, and 13,
              survive any termination or expiration of this Agreement. No other
              provisions of this Agreement survive the expiration or earlier
              termination of this A
            </span>
            <a id="id.37m2jsg" />
            <span className="c3">greement.</span>
          </li>
        </ol>
        <ol className="c5 lst-kix_list_20-0" start="15">
          <li className="c0">
            <span className="c6 c4 c11">Miscellaneous</span>
            <a id="id.1mrcu09" />
            <span className="c3">. </span>
          </li>
        </ol>
        <ol className="c5 lst-kix_list_20-1 start" start="1">
          <li className="c1">
            <span className="c6 c4">Entire Agreement</span>
            <span className="c3">
              . This Agreement, together with any other documents incorporated
              herein by reference and all related Exhibits, constitutes the sole
              and entire agreement of the Parties with respect to the subject
              matter of this Agreement and supersedes all prior and
              contemporaneous understandings, agreements, and representations
              and warranties, both written and oral, with respect to such
              subject matter. In the event of any inconsistency between the
              statements made in the body of this Agreement, the related
              Exhibits, and any other documents incorporated herein by
              reference, the following order of precedence governs: (i) first,
              this Agreement, excluding its Exhibits; (ii) second, the Exhibits
              to this Agreement as of the Effective Date;
            </span>
            <a id="id.46r0co2" />
            <span className="c3">
              &nbsp;and (iii) third, any other documents incorporated herein by
              reference.
            </span>
          </li>
          <li className="c1">
            <span className="c6 c4">Notices</span>
            <span className="c3">
              . All notices, requests, consents, claims, demands, waivers, and
              other communications hereunder (each, a &quot;
            </span>
            <span className="c6 c4">Notice</span>
            <span className="c3">
              &quot;) must be in writing and addressed to the Parties at the
              addresses set forth on the first page of this Agreement (or to
              such other address that may be designated by the Party giving
              Notice from time to time in accordance with this Section). All
              Notices must be delivered by personal delivery, nationally
              recognized overnight courier (with all fees pre-paid), facsimile
              or email (with confirmation of transmission), or certified or
              registered mail (in each case, return receipt requested, postage
              pre-paid). Except as otherwise provided in this Agreement, a
              Notice is effective only: (i) upon receipt by the receiving Party;
              and (ii) if the Party giving the Notice has complied with the
              requirements{" "}
            </span>
            <a id="id.2lwamvv" />
            <span className="c3">of this Section.</span>
          </li>
          <li className="c1">
            <span className="c6 c4 c11">Force Majeure</span>
            <span className="c3">
              . In no event shall FirstLine Social be liable to Customer, or be
              deemed to have breached this Agreement, for any failure or delay
              in performing its obligations under this Agreement, if and to the
              extent such failure or delay is caused by any circumstances beyond
              FirstLine Social&#39;s reasonable control, including but not
              limited to acts of God, pandemic, flood, fire, earthquake,
              explosion, war, terrorism, invasion, riot or other civil unrest,
              strikes, labor stoppages or slowdowns
            </span>
            <a id="id.111kx3o" />
            <span className="c3">
              &nbsp;or other industrial disturbances, or passage of law or any
              action taken by a governmental or public authority, including
              imposing{" "}
            </span>
            <a id="id.3l18frh" />
            <span className="c3">an embargo.</span>
          </li>
          <li className="c1">
            <span className="c6 c4">Amendment and Modification; Waiver</span>
            <span className="c3">
              . No amendment to or modification of this Agreement is effective
              unless it is in writing and signed by an authorized representative
              of each Party. No waiver by any Party of any of the provisions
              hereof will be effective unless explicitly set forth in writing
              and signed by the Party so waiving. Except as otherwise set forth
              in this Agreement, (i) no failure to exercise, or delay in
              exercising, any rights, remedy, power, or privilege arising from
              this Agreement will operate or be construed as a waiver thereof,
              and (ii) no single or partial exercise of any right, remedy,
              power, or privilege hereunder will preclude any other or further
              exercise thereof or the exercis
            </span>
            <a id="id.206ipza" />
            <span className="c3">
              e of any other right, remedy, power, or privilege.
            </span>
          </li>
          <li className="c1">
            <span className="c6 c4">Severability</span>
            <span className="c3">
              . If any provision of this Agreement is invalid, illegal, or
              unenforceable in any jurisdiction, such invalidity, illegality, or
              unenforceability will not affect any other term or provision of
              this Agreement or invalidate or render unenforceable such term or
              provision in any other jurisdiction. Upon such determination that
              any term or other provision is invalid, illegal, or unenforceable,
              the Parties shall negotiate in good faith to modify this Agreement
              so as to effect their original intent as closely as possible in a
              mutually acceptable manner in order that the transactions
              contemplated hereby be consummated as origi
            </span>
            <a id="id.4k668n3" />
            <span className="c3">
              nally contemplated to the greatest extent possible.
            </span>
          </li>
          <li className="c1">
            <span className="c6 c4">
              Governing Law; Submission to Jurisdiction
            </span>
            <span className="c3">
              . This Agreement is governed by and construed in accordance with
              the internal laws of the State of Oklahoma without giving effect
              to any choice or conflict of law provision or rule that would
              require or permit the application of the laws of any jurisdiction
              other than those of the State of Oklahoma. Any legal suit, action,
              or proceeding arising out of or related to this Agreement or the
              licenses granted hereunder will be instituted in the federal
              courts of the United States or the courts of the State of Oklahoma
              in each case located in the city of Oklahoma City and County of
              Oklahoma, and each Party irrevocably submits to the jurisdiction
              of such courts in any such s
            </span>
            <a id="id.2zbgiuw" />
            <span className="c3">uit, action, or proceeding.</span>
          </li>
          <li className="c1">
            <span className="c6 c4">Assignment</span>
            <span className="c3">
              . Customer may not assign any of your rights or delegate any of
              your obligations hereunder, in each case whether voluntarily,
              involuntarily, by operation of law or otherwise, without the prior
              written consent of FirstLine Social. Any purported assignment or
              delegation in violation of this Section will be null and void. No
              assignment or delegation will relieve the assigning or delegating
              Party of any of its obligations hereunder. This Agreement is
              binding upon and inures to the benefit of the Parties and their
              respective permitted successors and ass
            </span>
            <a id="id.1egqt2p" />
            <span className="c3">igns. </span>
          </li>
          <li className="c1">
            <span className="c6 c4 c11">Export Regulation</span>
            <span className="c3">
              . Customer shall comply with all applicable federal laws,
              regulations, and rules, and complete all required undertakings
              (including obtaining any necessary export license or other
              governmental approval), that prohibit or restrict the export or
              re-export of the Services or any Customer
            </span>
            <a id="id.3ygebqi" />
            <span className="c3">&nbsp;Data outside the US. </span>
          </li>
        </ol>
        <a id="id.2dlolyb" />
        <ol className="c5 lst-kix_list_20-1" start="9">
          <li className="c1">
            <span className="c6 c4">Equitable Relief</span>
            <span className="c3">
              . Each Party acknowledges and agrees that a breach or threatened
              breach by such Party of any of its obligations under Section 9 or,
              in the case of Customer, Section 4 would cause the other Party
              irreparable harm for which monetary damages would not be an
              adequate remedy and agrees that, in the event of such breach or
              threatened breach, the other Party will be entitled to equitable
              relief, including a restraining order, an injunction, specific
              performance, and any other relief that may be available from any
              court, without any requirement to post a bond or other security,
              or to prove actual damages or that monetary damages are not an
              adequate remedy. Such remedies are not exclusive a
            </span>
            <a id="id.sqyw64" />
            <span className="c3">
              nd are in addition to all other remedies that may be available at
              law, in equity, or otherwise.{" "}
            </span>
          </li>
          <li className="c1">
            <span className="c6 c4">Counterparts</span>
            <span className="c3">
              . This Agreement may be executed in counterparts, each of which is
              deemed an original, but all of which together are deemed to be one
              and the same agreement.
            </span>
          </li>
        </ol>
        <ol className="c5 lst-kix_list_20-0" start="15">
          <li className="c0">
            <span className="c6 c4 c11">YouTube's Terms of Services</span>
            <a id="id.1mrcu09" />
            <span className="c3">. </span>
          </li>
        </ol>
        <ol className="c5 lst-kix_list_20-1 start" start="1">
          <li className="c1">
            <span className="c6 c4">Link of interest. </span>
            <a
              className="c9"
              href="https://www.google.com/url?sa=D&q=https://www.youtube.com/t/terms&ust=1612466940000000&usg=AOvVaw3ZJLl1apUL72ytpnapOtQz&hl=en&source=gmail"
            >
              YouTube's Terms of Services
            </a>
          </li>
        </ol>

        <p className="c7">
          <span className="c3" />
        </p>
        <p className="c18">
          <span className="c3">&nbsp;</span>
        </p>
        <a id="id.3cqmetx" />
        <p className="c18 c22">
          <span className="c3" />
        </p>
        <p className="c14">
          <span className="c3" />
        </p>
        <div>
          <p className="c14">
            <span className="c6 c15" />
          </p>
        </div>
      </div>
    </div>
  )
}

export default TermsConditions



// WEBPACK FOOTER //
// ./src/pages/PrivacyTermsPages/TermsConditions/index.js